var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notification-container',{attrs:{"notifications":_vm.notifications}}),_vm._v(" "),_c('toggle-button',_vm._b({attrs:{"disabled":_vm.disabled},on:{"input":_vm.sendRequest}},'toggle-button',{color: _vm.color, labels: _vm.labels, sync: _vm.sync, value: _vm.value, width: _vm.width},false))],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e5cf2ba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/Utility/Buttons/ApiToggleButton.vue
// module id = 843
// module chunks = 0 1